import React, { useContext, useEffect, useState } from 'react'
import RentPromo from './RentPromo'
import RentPlaces from './RentPlaces'
import Loading from '../../components/Loading'
import { faAngleLeft, faAngleRight, faEnvelopeOpen, faLocationDot, faSquarePhone } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { store } from '../../components/HOC/State'
import { axiosInstance } from '../../const/axiosInstance'
import { translate } from '../translate'
import { Parser } from 'html-to-react'
import stylesContact from '../Museum/museum.module.css'
import styles from './rent.module.css'
import stylesExpo from '../Expo/expo.module.css'
import CustomModal from '../../components/Modal/CustomModal'
import { BACKEND_URL } from '../../const/Constant'

export default function Rent() {
    const [arr, setArr] = useState([])
    const [rentText, setRentText] = useState("")
    const [loading, setLoading] = useState(false)
    const [updateed, setUpdated] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [openedIndex, setOpenedIndex] = useState(0)
    const {offset, setOffset, setOffsetUpdated, selectedLang} = useContext(store)

    let lang = translate[selectedLang]
    const limit = 20
    const htmlParser = new Parser()

    useEffect(() => {
      setOffset(0)
      setUpdated(true)
    }, [])

    useEffect(() =>{
      (async() => {
        if(updateed){
          setLoading(true)
          const res = await axiosInstance.get(`/use/rent?offset=${offset}&limit=${limit}`)
          if(res.data.status){
            setArr([...arr,...res.data.data])
            if(res.data.data.length == 20){
              setOffsetUpdated(false)
            }
          }else{
            setArr([...arr])
          }
          setLoading(false)
        }
      })()
    }, [offset, updateed])

      useEffect(() => {
          (
              async () => {
                  const res = await axiosInstance.get(`/use/rent-text`)
                  if(res.data.status){
                      setRentText(res.data.data)
                  }else{
                      setRentText("")
                  }
              }
          )()
    
      }, [])

      const close = () => {
        setShowModal(false)
    }

    const slideLeft = () => {
      if(openedIndex){
        setOpenedIndex(p => p - 1)
      }else{
        setOpenedIndex(arr.length - 1)
      }
    }
  
    const slideRight = () => {
      if(openedIndex != arr.length - 1){
        setOpenedIndex(p => p + 1)
      }else{
        setOpenedIndex(0)
      }
    }

  return (
    <div className={styles['rent-main']}>
        <div >
            <RentPromo/>
        </div>
        <div className={stylesContact['contact-div']}>
            <div className={stylesContact['contact-part-div']}>
                <FontAwesomeIcon className={stylesContact['contact-part-icon']} icon={faSquarePhone} />
                <p className={stylesContact['contact-part-title']}>{lang.tr_telephone}</p>
                <p>+37415 27 27 00</p>
            </div>
            <div className={stylesContact['contact-part-div']}>
                <FontAwesomeIcon className={stylesContact['contact-part-icon']} icon={faEnvelopeOpen} />
                <p className={stylesContact['contact-part-title']}>{lang.tr_mail}</p>
                <a href='mailto: sc@mergelyan.com'>sc@mergelyan.com</a>
            </div>
            <div className={stylesContact['contact-part-div']}>
                <FontAwesomeIcon className={stylesContact['contact-part-icon']} icon={faLocationDot} />
                <p className={stylesContact['contact-part-title']}>{lang.tr_address}</p>
                <p>{lang.tr_address2}</p>
            </div>
        </div>
            <div className={`${styles['images-div']} ${styles['rent-descr-text']}`}>
                    {htmlParser.parse(rentText[`${selectedLang}text`]?.
                                        replaceAll(`iframe width="auto" height="auto"`, `iframe width="${0.6*window.innerWidth}" height="${0.6*window.innerWidth/1.6}" allowfullscreen`).
                                        replaceAll("alt=\"undefined\" style=\"height: auto;width: auto\"/>", `alt="undefined" "height="auto" width="${0.6*window.innerWidth}"/>`))
                    }
            </div>
        <div className={styles['rent-places-list']}>
          {arr.length ? (
            arr.map((el, i) => <RentPlaces key={el._id} el={el} setShowModal={setShowModal} index={i} setOpenedIndex={setOpenedIndex}/>)
          ) : (
           !loading ? <p className='empty-message'>{lang.tr_noPublished}</p> : null  
          )}
            {loading ? <Loading width={200}/> : ""}
            {showModal && 
                          <CustomModal close={close}>
                              <img src={BACKEND_URL + arr[openedIndex].image} alt='rent-image'/>
                              <div className={stylesExpo['control-div']}>
                                <div onClick={slideLeft} className={`${stylesExpo['left']} ${stylesExpo['control-btn']}`}>
                                    <FontAwesomeIcon className={styles['control-icon']} icon={faAngleLeft} />
                                </div>
                                <div onClick={slideRight} className={`${stylesExpo['right']} ${stylesExpo['control-btn']}`}>
                                    <FontAwesomeIcon className={stylesExpo['control-icon']} icon={faAngleRight} />
                                </div>
                            </div>
                          </CustomModal>}
        </div>
    </div>
  )
}
